import { combineReducers } from "redux";
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { reportsAPI } from "../../../api/reports";
import { createActions } from "../../factory/actionFactory";
import { START } from "../../../constants/action-postfix";
import { loaderReducer } from "./loader/loaderReducer";
import { formReducer } from "./form/formReducer";
import { dataReducer } from "./data/dataReducer";



export const PERFORMANCE_REQUEST = "PERFORMANCE_REQUEST";
export const SET_FORM_DATA = "SET_PERFORMANCE_FORM_DATA";

export const performanceReducer = combineReducers({
    form: formReducer,
    data: dataReducer,
    loader: loaderReducer,
});

//actions
export const performanceActions = createActions('performance', PERFORMANCE_REQUEST);
export const setFormData = payload => ({ type: SET_FORM_DATA, payload });

// SAGAS
export function* performanceWatcher() {
    yield takeLatest(`${PERFORMANCE_REQUEST}${START}`, performanceWorker)
}

const unwrap = (response) => {
    const answer = response?.data?.Answer
    if (!answer || answer.Result !== 'Success') {
        const desc = answer?.Data_?.Error?.desc || 'Unknown API error'
        throw new Error(desc)
    }
    const data = answer.Data_ || {}
    const rows = data.items || []
    return { academicYear: data.academicYear, rows }
}

function* performanceWorker() {
    try {
        const auth = yield select(state => state.auth.data)
        const form = yield select(state => state.reports.performance.form)
        const params = { ...auth, ...form }
        const [summaryRes, monitoringRes] = yield all([
            call(reportsAPI.performanceSummary, params),
            call(reportsAPI.performanceMonitoring, params),
        ])
        const data = {
            summary: unwrap(summaryRes),
            monitoring: unwrap(monitoringRes),
        }
        yield put(performanceActions.performanceRequestSuccess(data))
    } catch (error) {
        yield put(performanceActions.performanceRequestError(error))
    }
}
